import React from 'react';
import { useSelector } from 'react-redux';
import TaxBillDetail from '../../components/taxIssuedmng/TaxBillDetail';

const TaxBillDetailContainer = () => {
  const { taxbill, roInfo } = useSelector(
    ({ taxIssuedModule }) => ({
      taxbill: taxIssuedModule.taxbill.taxbill,
      roInfo: taxIssuedModule.taxbill.roInfo,
    }),
  );

  return <TaxBillDetail taxbill={taxbill} roInfo={roInfo} />
};

export default TaxBillDetailContainer;
